import { toast } from 'sonner';

import { useApiMutation, useApiQuery } from '@/modules/common';

import { CreateModelBody, ModelsUploadUrlData } from '../types';
import { useModelAttributes } from './useModelAttributes';

export function useCreateModel() {
  const { data: optionsData } = useModelAttributes();

  const {
    data: uploadUrlData,
    isFetching,
    refetch: refetchUploadUrl,
  } = useApiQuery<ModelsUploadUrlData>('/models/upload-url', {
    queryKey: ['modelDetailsUploadUrl'],
    initialData: null,
  });

  const createModelMutation = useApiMutation<CreateModelBody>(
    '/models',
    {
      method: 'POST',
    },
    {
      onError: () => {
        toast.error('Uh oh! Something went wrong.');
      },
    }
  );

  return {
    isFetching,
    optionsData,
    uploadUrlData,
    refetchUploadUrl,
    createModelMutation,
  } as const;
}
